// Hand-written, not generated: a styled native <select>. The board's forms
// keep the browser's own select (keyboard, mobile pickers, the `option`
// roles and `selectOptions` the tests drive) — shadcn's Radix Select is a
// popover, which would change all of that for no gain on these forms.
// Styled to match ui/input.jsx (projects/tailwind-migration, #33).
import { forwardRef } from "react";
import { ChevronDownIcon } from "lucide-react";
import { cn } from "@/lib/utils";

const NativeSelect = forwardRef(function NativeSelect(
  { className, children, ...props },
  ref,
) {
  return (
    <div className="relative">
      <select
        ref={ref}
        data-slot="native-select"
        className={cn(
          "h-9 w-full min-w-0 appearance-none rounded-md border border-input bg-transparent py-1 pr-8 pl-3 text-base shadow-xs transition-[color,box-shadow] outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-input/30",
          "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring",
          "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDownIcon
        aria-hidden="true"
        className="pointer-events-none absolute top-1/2 right-2.5 size-4 -translate-y-1/2 text-muted-foreground"
      />
    </div>
  );
});

export { NativeSelect };
